import gql from 'graphql-tag';

export default id => gql`
  query {
    getPackageById(input: { id: "${id}" }) {
      id
      name
      description
      minimumQuantity
      maximumQuantity
      salesChannel
      marketSegment
      accountType
      accountSubType
      country
      currency
      startDate
      endDate
      status
      userId
      components{
        index
        serviceType
        serviceAddOn
        discountOfferId
        discountOfferName
        bundleId
        bundleName
        validityDuration
        validityUnit
        discountAmountOverride
        discountPercentOverride
      }
    }
  }
`;
